import {
  NotificationCategoriesEnum,
  NotificationCategoriesValueType,
} from '../notifications/notification/notification-types/notifications-categories-enum';

import { Tag, TagProps } from './tag';

export const notificationCategoryNumber: Record<
  NotificationCategoriesValueType,
  number
> = {
  [NotificationCategoriesEnum.valuesEnum.Job]: 1,
  [NotificationCategoriesEnum.valuesEnum.Task]: 2,
  [NotificationCategoriesEnum.valuesEnum.Mention]: 3,
};

const getNotificationCategory = (
  value: number | string
): { label: string; color: TagProps['color'] } => {
  if (
    value === notificationCategoryNumber.Job ||
    value === NotificationCategoriesEnum.valuesEnum.Job
  ) {
    return {
      label: NotificationCategoriesEnum.valuesEnum.Job,
      color: 'blue-light',
    };
  }

  if (
    value === notificationCategoryNumber.Task ||
    value === NotificationCategoriesEnum.valuesEnum.Task
  ) {
    return {
      label: NotificationCategoriesEnum.valuesEnum.Task,
      color: 'green-light',
    };
  }

  return {
    label: NotificationCategoriesEnum.valuesEnum.Mention,
    color: 'pink-light',
  };
};

export const NotificationCategoryTag: React.FC<{
  value: number | string;
  testId?: string;
}> = ({ value, testId = `notification-tag` }) => {
  const { label, color } = getNotificationCategory(value);

  return <Tag label={label} color={color} data={{ testid: testId }} />;
};
